import React, {Component, Fragment} from 'react';

export default class ConsequencesCell extends Component {
  constructor(props){
    super(props);
    this.state = {
      height: '97px'
    }
  }

  showMore = (evt) => {
    evt.stopPropagation();
    this.setState({ height: 'auto' });
  }

  showLess = (evt) => {
    evt.stopPropagation();
    this.setState({ height: '97px' });
  }

  render() {
    const { children, colIndex } = this.props;
    const { height } = this.state;
    const { showLess, showMore } = this;
    return (
      <Fragment>
        <div column_index={colIndex} className="consequences-cell-content" style={{height:height}} title={children}>{ children }</div>
        <div>
          {
            height == '97px' && children.toString().length > 99 &&
            <span onClick={showMore} className="anchor-button font-90-percent">Show more</span>
          }
          {
            height == 'auto' && 
            <span onClick={showLess} className="anchor-button font-90-percent">Show less</span>
          }
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/consequence_cell.js